export default theme => ({
  waitingText: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  recording_download__main__disabled: {
    color: theme.palette.blue.disabled,
  }
});
